import React, { useEffect, useState } from 'react';
import DragAndDrop from '../common/ListDragAndDrab/dragAndDrop';

const Shiftorder = (props) => {
    const { shiftReleaseOderWaitTimeList, getShiftoderData, errors,
        formData, closeShiftRelease, draggedData } = props;

    const fData = formData ? formData : {
        "time": "",
        "authorizedUser": "",
    }
    const [form, setForm] = useState(fData);


    useEffect(() => {
        getShiftoderData(form, 'form');
    }, [form])


    const getOrderedData = (data) => {
        getShiftoderData(data, 'data');
    }

    const updatVal = (target) => {
        if (target.type === 'checkbox') {
            setForm({
                ...form,
                [target.name]: target.checked
            });
        } else {
            setForm({
                ...form,
                [target.name]: target.value
            });
        }
    }

    const options = [];
    for (let i = 2; i <= 100; i++) {
    options.push(<option key={i} value={i}>{i}</option>);
    }

    return (
        <div>
            <div className="text-center">{errors['error'] && <span style={{ color: '#dc3545' }}>{errors['error']}</span>}</div>
            <DragAndDrop data={draggedData} getOrderedData={getOrderedData} closeShiftRelease={closeShiftRelease} />
            {errors['data'] && <div className="text-center" style={{ color: '#dc3545' }}>{errors['data']}</div>}
            <div className='col-lg-4 col-md-4'>
                <label htmlFor={'matchingCriteria'}>How long to wait before pushing the job to all authorized users?</label>
                <div className="form-group">
                    <select className="form-select"
                        data-placeholder="Matching Criteria"
                        value={form.time}
                        name={"time"}
                        onChange={(event) => { updatVal(event.target) }}
                    >
                        <option value={""}>--Select--</option>
                        {
                            shiftReleaseOderWaitTimeList?.map((option) => (
                                <option key={option.id} value={option.id}>{option.name}</option>
                            ))
                        }
                    </select>
                    {errors['time'] && <div className="invalid-input">{errors['time']}</div>}
                </div>
            </div>
            <div className="col-lg-6 col-md-6 ms-4">
                <div>
                <div>
                    <input className="form-check-input" value={form.authorizedUser} checked={form.authorizedUser} name={'authorizedUser'} type="checkbox" onChange={(event) => { updatVal(event.target) }} />
                </div>
                <label className="form-check-label" 
                // style={{ float: 'left' }} 
                htmlFor="flexSwitchCheckDefault">All Authorized Users</label> 
                </div>
                { props?.NoOfShiftsneeded === false ? ("") : (
                <div className='d-flex gap-4'>
                    <label className='mt-5 fw-bold'>No of shifts needed</label>
                    <select className='form-select mt-4' style={{width: "60px"}} onChange={(e) => props?.setNoOfShiftNeeded(e.target.value)}>
                        
                    <option value="1">1</option>
                    {options}
                    </select>
                </div> 
                )
                }
            </div>
        </div>
    
    )
}

export default Shiftorder;
